import { Row } from 'src/components/atoms/Row';
import styled from 'styled-components/macro';

export const StyledRow = styled(Row)`
  @media ${({ theme }) => theme.device.mobile}, ${({ theme }) => theme.device.xs} {
    justify-content: flex-start !important;
  }
`;
